<template>
  <div v-if="visible" class="initializing-container">
    <!-- eslint-disable max-len -->
    <svg
      class="initializing-spinner"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      fill="white"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8 1.78915C4.56984 1.78915 1.78915 4.56984 1.78915 8C1.78915 11.4302 4.56984 14.2108 8 14.2108C11.4302 14.2108 14.2108 11.4302 14.2108 8C14.2108 7.72386 14.4347 7.5 14.7108 7.5C14.987 7.5 15.2108 7.72386 15.2108 8C15.2108 11.9824 11.9824 15.2108 8 15.2108C4.01755 15.2108 0.789146 11.9824 0.789146 8C0.789146 4.01755 4.01755 0.789146 8 0.789146C8.27614 0.789146 8.5 1.013 8.5 1.28915C8.5 1.56529 8.27614 1.78915 8 1.78915Z"
      />
    </svg>
    <!-- eslint-enable max-len -->
  </div>
</template>

<script setup lang="ts">
import { onBeforeUnmount, ref } from 'vue';

const props = withDefaults(defineProps<{ delay?: number }>(), { delay: 300 });

const visible = ref(false);
const timer = setTimeout(() => {
  visible.value = true;
}, props.delay);

onBeforeUnmount(() => clearTimeout(timer));
</script>

<style scoped lang="scss">
.initializing-container {
  width: 100%;
  height: 100svh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.initializing-spinner {
  animation: initializing-spin 1s var(--cubic-bezier) infinite;
}

@keyframes initializing-spin {
  from {
    rotate: 0deg;
  }
  to {
    rotate: 360deg;
  }
}
</style>
